<template>
  <li style="z-index: 2">
    <code
      :draggable="mode == 'edit'"
      @dragstart="dragStart"
      @dragover.prevent
      @drop.stop="dragFinish($event)"
      :class="itemSelected ? 'node-selected' : ''"
    >
      <v-col cols="12" @click="handleClick">
        <div class="menu-button" v-if="mode == 'edit'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
            </template>
            <v-list dense class="ma-0 pa-0">
              <v-list-item @click="removeItem">
                <v-list-item-title>Remove</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="subtitle-2">
          {{ item.providerFilterValue.value }}
        </div>
      </v-col>
    </code>

    <ul v-if="hasChildren">
      <organogram-node
        v-for="(child, idx) in item.children"
        :key="idx"
        :item="child"
        :mode="mode"
        @groupDeleted="groupDeleted"
      ></organogram-node>
    </ul>
  </li>
</template>

<script>
export default {
  props: ["item", "mode"],
  data() {
    return {};
  },
  computed: {
    hasChildren() {
      return this.item.children.length > 0;
    },
    selectedFilters() {
      return this.$store.getters.getSelectedFilters;
    },
    selectedFilterIds() {
      return this.$store.getters.getSelectedFilterIds;
    },
    itemSelected() {
      let self = this;

      var found = self.selectedFilterIds.includes(
        self.item.providerFilterValue.id
      );

      return found;
    },
  },
  methods: {
    dragStart(ev) {
      let self = this;

      self.$store.commit(`setDraggedItem`, self.item);

      ev.dataTransfer.setData("methodType", "update");
    },
    dragFinish(ev) {
      let self = this;

      let draggedItem = self.$store.getters.getDraggedItem;

      let methodType = ev.dataTransfer.getData("methodType");

      if (methodType == "create") {
        self.addToGroup(ev.dataTransfer.getData("filterId"));
      } else if (methodType == "update") {
        if (draggedItem.parentId == null) {
          self.updateGroup(draggedItem, null);
        } else {
          self.$store.getters.getNode(draggedItem.parentId).then((parent) => {
            self.updateGroup(draggedItem, parent);
          });
        }
      }
    },
    addToGroup(itemId) {
      let self = this;

      self
        .post(`Hierarchy/CreateFilter`, {
          hierarchyId: self.$route.params.id,
          providerFilterValueId: itemId,
          parentId: self.item.id,
        })
        .then((r) => {
          if (r.data.success) {
            self.item.children.push(r.data.data);
          }
        });
    },
    updateGroup(item, parent) {
      let self = this;

      item.parentId = self.item.id;

      self.put(`Hierarchy/UpdateFilter?filterId=${item.id}`, item).then((r) => {
        if (r.data.success) {
          if (parent == null) {
            let organogram = self.$store.getters.getOrganogram;
            console.log(organogram);

            organogram.splice(organogram.indexOf(item), 1);
          } else {
            parent.children.splice(parent.children.indexOf(item), 1);
          }

          self.item.children.push(item);
        }
      });
    },
    removeItem() {
      let self = this;

      self.delete(`Hierarchy/DeleteFilter?id=${self.item.id}`).then((r) => {
        if (r.data.success) {
          self.$emit(`groupDeleted`, self.item);
        }
      });
    },
    groupDeleted(item) {
      let self = this;

      self.item.children.splice(self.item.children.indexOf(item), 1);
    },
    handleClick() {
      let self = this;

      if (self.mode == "edit") {
        return;
      }

      if (self.mode == "select") {
        if (self.itemSelected) {
          self.$store.commit(`removeFilter`, self.item.providerFilterValue);
          self.$store.commit(
            `removeFilterId`,
            self.item.providerFilterValue.id
          );
        } else {
          self.$store.commit(`pushFilter`, self.item.providerFilterValue);
          self.$store.commit(`pushFilterId`, self.item.providerFilterValue.id);
        }
      }
    },
  },
};
</script>

<style>
.node-item {
  border: 1px solid;
  width: auto;
  padding: 10px;
}
</style>